var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCng = function SvgCng(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeWidth: 1.5,
    d: "M20.25 25.286V11M20.25 41V26.714M47.391 25.286V11M47.391 41V26.714"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7F0",
    d: "M10.004 12v28c-11.5-1.5-11.26-26.613 0-28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeWidth: 1.5,
    d: "M52.86 11.75c5.66 0 10.25 4.59 10.25 10.25v8c0 5.66-4.59 10.25-10.25 10.25H12.001c-5.66 0-10.25-4.59-10.25-10.25v-8c0-5.66 4.59-10.25 10.25-10.25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8CE99A",
    stroke: "#8CE99A",
    strokeLinejoin: "round",
    d: "M34.786 18.235a1.5 1.5 0 0 0-1.853 0l-8.382 6.586a1.5 1.5 0 0 0 0 2.358l8.382 6.586a1.5 1.5 0 0 0 1.853 0l8.381-6.586a1.5 1.5 0 0 0 0-2.358z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M64 22v2.7h3v3.6h-3V31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#36354C",
    strokeLinecap: "round",
    d: "M30.997 26.65c0-2.273 2.857-4.221 2.857-4.221s2.857 1.948 2.857 4.22c0 .775-.301 1.519-.837 2.067a2.83 2.83 0 0 1-2.02.855 2.83 2.83 0 0 1-2.02-.855 2.96 2.96 0 0 1-.837-2.067Z"
  })));
};
export default SvgCng;